(function () {
  function qs(sel, root=document){ return root.querySelector(sel); }
  function qsa(sel, root=document){ return Array.from(root.querySelectorAll(sel)); }

  const MOBILE_SPB_MEDIA = window.matchMedia('(max-width: 989px)');

  function syncGlobalSpbState() {
    const stickyBarSuppressed = document.body.classList.contains('ry-pswp-open');
    const anyActive = qsa('[data-spb]').some((item) => {
      return item.classList.contains('is-visible') || item.classList.contains('is-size-open');
    });

    document.body.classList.toggle('spb-active', MOBILE_SPB_MEDIA.matches && anyActive && !stickyBarSuppressed);
  }

  function openCartDrawerBestEffort() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    const cartButton =
      qs('[data-drawer-trigger="cart"]') ||
      qs('[data-cart-drawer-open]') ||
      qs('a[href="/cart"]') ||
      qs('button[name="checkout"]');

    if (cartButton) cartButton.click();
  }

  async function addToCart(variantId, quantity=1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  function parseVariantMap(bar) {
    const variantJson = qs('[data-spb-variants]', bar);
    if (!variantJson) return new Map();

    try {
      const parsed = JSON.parse(variantJson.textContent || '[]');
      return new Map(parsed.map((variant) => [String(variant.id), variant]));
    } catch (error) {
      console.warn('SPB variant map parse failed', error);
      return new Map();
    }
  }

  function getProductRoot(bar) {
    const rootId = bar.dataset.productRootId || (bar.dataset.productId ? `product-${bar.dataset.productId}` : '');
    return rootId ? document.getElementById(rootId) : null;
  }

  function getButtonsArea(bar) {
    const productRoot = getProductRoot(bar);
    return productRoot ? (qs('.cc-product-buttons', productRoot) || productRoot) : document;
  }

  function getCurrentVariantInput(bar) {
    const productRoot = getProductRoot(bar) || document;
    return (
      qs('form[id^="product-form-buttons-"] input[name="id"]', productRoot) ||
      qs('form[id^="product-form-buttons-"] #formVariantId', productRoot) ||
      qs('.js-prod-form-submit input[name="id"]', productRoot) ||
      qs('#formVariantId', productRoot)
    );
  }

  function getVariantState(bar, variantMap) {
    const variantInput = getCurrentVariantInput(bar);
    const fallbackId = bar.dataset.initialVariantId || '';
    const variantId = String((variantInput && variantInput.value) || fallbackId || '');
    const variant = variantMap.get(variantId) || null;

    return {
      id: variantId,
      available: variant ? !!variant.available : bar.dataset.initialAvailable === 'true',
      price: (variant && variant.price) || bar.dataset.initialPrice || ''
    };
  }

  function scoreNotifyCandidate(element) {
    const haystack = [
      element.id || '',
      element.className || '',
      element.getAttribute('aria-label') || '',
      element.getAttribute('data-testid') || '',
      element.getAttribute('title') || '',
      element.textContent || ''
    ].join(' ').toLowerCase();

    let score = 0;
    if (haystack.includes('klaviyo')) score += 5;
    if (haystack.includes('notify me')) score += 5;
    if (haystack.includes('back in stock')) score += 4;
    if (haystack.includes('when available')) score += 4;
    if (haystack.includes('email me')) score += 3;
    if (element.classList.contains('cc-klaviyo-bis-button')) score += 6;
    if (element.classList.contains('klaviyo-bis-trigger')) score += 6;
    if (element.tagName && element.tagName.toLowerCase() === 'button') score += 1;
    return score;
  }

  function findNotifyTrigger(bar) {
    const buttonsArea = getButtonsArea(bar);
    if (!buttonsArea) return null;

    const excludedSelector = [
      '.js-ajax-submit',
      '.product__quantity-down',
      '.product__quantity-up',
      '.product__quantity-input'
    ].join(', ');

    const candidates = qsa('button, a, [role="button"]', buttonsArea)
      .filter((element) => {
        if (!(element instanceof Element)) return false;
        if (element.closest('[data-spb]')) return false;
        if (element.matches(excludedSelector)) return false;
        if (element.closest('.product__quantity, .notify-form__inner-wrapper, .product-form__notify-form')) return false;
        if (element.disabled) return false;
        return scoreNotifyCandidate(element) > 0;
      })
      .sort((a, b) => scoreNotifyCandidate(b) - scoreNotifyCandidate(a));

    return candidates[0] || null;
  }

  function waitForNotifyTrigger(bar, timeout=1600) {
    const existing = findNotifyTrigger(bar);
    if (existing) return Promise.resolve(existing);

    const buttonsArea = getButtonsArea(bar);
    if (!buttonsArea) return Promise.resolve(null);

    return new Promise((resolve) => {
      let settled = false;
      const cleanup = () => {
        observer.disconnect();
        clearTimeout(timer);
      };
      const finish = (element) => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve(element || null);
      };

      const observer = new MutationObserver(() => {
        const found = findNotifyTrigger(bar);
        if (found) finish(found);
      });

      observer.observe(buttonsArea, { childList: true, subtree: true, attributes: true });

      const timer = setTimeout(() => finish(findNotifyTrigger(bar)), timeout);
    });
  }

  function initBar(bar) {
    const btn = qs('[data-spb-btn]', bar);
    const drawer = qs('[data-spb-drawer]', bar);
    const needsSelection = bar.dataset.needsSelection === 'true';
    const variantMap = parseVariantMap(bar);
    const productRoot = getProductRoot(bar);

    const formButtons =
      (productRoot && (
        qs('form[id^="product-form-buttons-"]', productRoot) ||
        qs('.product-form__buttons', productRoot) ||
        qs('product-form form[action^="/cart/add"]', productRoot) ||
        qs('form[action^="/cart/add"]', productRoot)
      )) ||
      qs('form[id^="product-form-buttons-"]') ||
      qs('.product-form__buttons') ||
      qs('product-form form[action^="/cart/add"]') ||
      qs('form[action^="/cart/add"]');

    const footer =
      qs('footer') ||
      qs('#shopify-section-footer') ||
      qs('[data-section-type="footer"]');

    function syncButtonState() {
      if (!btn) return;

      const variantState = getVariantState(bar, variantMap);
      const notifyMode = !variantState.available;
      const addPrefix = bar.dataset.labelAddPrefix || 'ADD TO CART - ';
      const selectPrefix = bar.dataset.labelSelectPrefix || 'SELECT YOUR SIZE - ';
      const notifyLabel = bar.dataset.labelNotify || 'NOTIFY ME';
      const nextLabel = notifyMode
        ? notifyLabel
        : `${needsSelection ? selectPrefix : addPrefix}${variantState.price || ''}`;

      btn.textContent = nextLabel.trim();
      bar.dataset.spbMode = notifyMode ? 'notify' : (needsSelection ? 'select' : 'add');
      bar.classList.toggle('is-notify-mode', notifyMode);

      if (notifyMode && drawer && !drawer.hasAttribute('hidden')) {
        drawer.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        bar.classList.remove('is-size-open');
      }
    }

    async function openNotifyFlow() {
      btn && btn.setAttribute('aria-busy', 'true');
      try {
        const trigger = await waitForNotifyTrigger(bar);
        if (trigger) {
          trigger.click();
          return;
        }
        console.warn('Sticky product bar could not find a Klaviyo notify trigger.');
      } finally {
        btn && btn.removeAttribute('aria-busy');
      }
    }

    if (!formButtons) {
      syncButtonState();
      bar.classList.add('is-visible');
      syncGlobalSpbState();
      return;
    }

    let formVisible = false;
    let footerVisible = false;

    function updateVisibility() {
      const shouldShow = (!formVisible) && (!footerVisible);
      bar.classList.toggle('is-visible', shouldShow);

      if (!shouldShow) {
        if (drawer && !drawer.hasAttribute('hidden')) drawer.setAttribute('hidden', '');
        btn && btn.setAttribute('aria-expanded', 'false');
        bar.classList.remove('is-size-open');
      }

      syncButtonState();
      syncGlobalSpbState();
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === formButtons) formVisible = entry.isIntersecting;
        if (footer && entry.target === footer) footerVisible = entry.isIntersecting;
      });
      updateVisibility();
    }, {
      root: null,
      threshold: 0.01,
      rootMargin: '0px 0px -15% 0px'
    });

    io.observe(formButtons);
    if (footer) io.observe(footer);

    btn?.addEventListener('click', async () => {
      syncButtonState();
      const mode = bar.dataset.spbMode || (needsSelection ? 'select' : 'add');

      if (mode === 'notify') {
        await openNotifyFlow();
        return;
      }

      if (needsSelection) {
        if (!drawer) return;

        const isOpen = !drawer.hasAttribute('hidden');
        if (isOpen) {
          drawer.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
          bar.classList.remove('is-size-open');
        } else {
          drawer.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
          bar.classList.add('is-size-open');
        }

        syncGlobalSpbState();
        return;
      }

      const variantInput = getCurrentVariantInput(bar);
      const variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!variantId) return;

      btn.disabled = true;
      try {
        await addToCart(variantId, 1);
        openCartDrawerBestEffort();
      } catch(e) {
        console.warn(e);
      } finally {
        btn.disabled = false;
      }
    });

    if (drawer) {
      const closeBtn = qs('[data-spb-close]', bar);
      closeBtn?.addEventListener('click', () => {
        drawer.setAttribute('hidden', '');
        btn?.setAttribute('aria-expanded', 'false');
        bar.classList.remove('is-size-open');
        syncGlobalSpbState();
      });

      qsa('[data-spb-variant-id]', drawer).forEach((sizeBtn) => {
        sizeBtn.addEventListener('click', async () => {
          const variantId = parseInt(sizeBtn.getAttribute('data-spb-variant-id'), 10);
          if (!variantId) return;

          try {
            await addToCart(variantId, 1);
            drawer.setAttribute('hidden', '');
            btn?.setAttribute('aria-expanded', 'false');
            bar.classList.remove('is-size-open');
            syncGlobalSpbState();
            openCartDrawerBestEffort();
          } catch(e) {
            console.warn(e);
          }
        });
      });

      drawer.addEventListener('click', (e) => {
        if (e.target === drawer) {
          drawer.setAttribute('hidden', '');
          btn?.setAttribute('aria-expanded', 'false');
          bar.classList.remove('is-size-open');
          syncGlobalSpbState();
        }
      });
    }

    const variantInput = getCurrentVariantInput(bar);
    variantInput?.addEventListener('change', syncButtonState);

    const buttonsArea = getButtonsArea(bar);
    if (buttonsArea) {
      new MutationObserver(syncButtonState).observe(buttonsArea, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }

    function syncPswp() {
      document.body.classList.toggle('spb--zoom-open', document.body.classList.contains('ry-pswp-open'));
      syncGlobalSpbState();
    }
    syncPswp();
    new MutationObserver(syncPswp).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (typeof MOBILE_SPB_MEDIA.addEventListener === 'function') {
      MOBILE_SPB_MEDIA.addEventListener('change', syncGlobalSpbState);
    } else if (typeof MOBILE_SPB_MEDIA.addListener === 'function') {
      MOBILE_SPB_MEDIA.addListener(syncGlobalSpbState);
    }

    syncButtonState();
  }

  function boot() {
    qsa('[data-spb]').forEach(initBar);
    syncGlobalSpbState();
  }

  window.addEventListener('pagehide', () => {
    document.body.classList.remove('spb-active');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
